(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.connectedCallback();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 300);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.body.classList.add('shopify-body-section-header-hidden', 'shopify-body-section-header-sticky');
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.add('shopify-body-section-header-sticky');
      document.body.classList.remove('shopify-body-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden') && document.body.classList.contains('shopify-body-section-header-sticky') && !document.body.classList.contains('shopify-body-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
if (!customElements.get('variant-offer-code')) {
  class VariantOfferCode extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => {
        if (!this.isConnected || this.controller) return;
        this.root = this.closest('product-info') || this.closest('.shopify-section');
        this.button = this.querySelector('[data-offer-copy]');
        this.label = this.querySelector('[data-offer-label]');
        this.status = this.querySelector('[data-offer-status]');
        if (!this.root || !this.button) return;
        try {
          this.variants = JSON.parse(this.querySelector('[data-offer-variants]').textContent);
        } catch (_) {
          this.hidden = true;
          return;
        }
        this.byId = new Map(this.variants.map(variant => [String(variant.id), variant]));
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.button.addEventListener('click', () => this.copyCode(), { signal });
        // Capture also receives non-bubbling change events on the theme's hidden input.
        this.root.addEventListener('change', event => this.onChange(event), { capture: true, signal });
        ['variant:change', 'variant:changed', 'product:variant-change'].forEach(name => {
          document.addEventListener(name, event => this.onVariantEvent(event), { signal });
        });
        window.addEventListener('popstate', () => {
          const id = new URL(window.location.href).searchParams.get('variant');
          this.showVariant(id || this.dataset.initialVariant);
        }, { signal });
        this.observeInputs();
        this.bindPubSub();
        // Theme scripts may be deferred; this also covers the initial parser upgrade.
        document.addEventListener('DOMContentLoaded', () => this.bindPubSub(), { once: true, signal });
        this.showVariant(this.variantInput()?.value || this.dataset.initialVariant);
      });
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.observer?.disconnect();
      this.unsubscribe?.();
      this.unsubscribe = null;
      if (this.label && this.status) this.resetCopy();
      this.copySequence = (this.copySequence || 0) + 1;
    }

    variantInput() {
      const form = document.getElementById(this.dataset.formId);
      if (form && this.root.contains(form)) return form.querySelector('[name="id"]');
      return this.root.querySelector('product-form form[action*="/cart/add"] [name="id"]');
    }

    ownsInput(input) {
      return input?.matches?.('[name="id"]') && this.root.contains(input) &&
        (input.form?.id === this.dataset.formId || input.closest('product-form'));
    }

    onChange(event) {
      const target = event.target;
      if (this.ownsInput(target)) {
        this.showVariant(target.value);
        return;
      }
      const picker = target.closest?.('variant-selects, variant-radios');
      if (!picker || !this.root.contains(picker)) return;
      // Resolve the selection immediately, before the theme's asynchronous price refresh.
      const options = Array.from(picker.querySelectorAll('select, fieldset'))
        .filter(group => group.tagName === 'SELECT' || !group.querySelector('select'))
        .map(group => group.tagName === 'SELECT' ? group.value : group.querySelector('input:checked')?.value);
      if (options.length !== this.variants[0]?.options.length) {
        this.showVariant(null);
        return;
      }
      const match = this.variants.find(variant => variant.options.every((value, index) => String(value) === options[index]));
      this.showVariant(match?.id);
    }

    onVariantEvent(event) {
      const data = event.detail?.data || event.detail || {};
      const sectionId = data.sectionId ?? data.section_id;
      const owner = event.target?.closest?.('product-info');
      if (sectionId != null && String(sectionId) !== this.dataset.sectionId) return;
      if (owner && owner !== this.root) return;
      if (Object.prototype.hasOwnProperty.call(data, 'variant')) {
        if (data.variant && this.byId.has(String(data.variant.id))) this.showVariant(data.variant.id);
        else if (sectionId != null || owner === this.root) this.showVariant(null);
      } else if (owner === this.root || sectionId != null) {
        this.showVariant(this.variantInput()?.value);
      }
    }

    bindPubSub() {
      if (this.unsubscribe || typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined' || !PUB_SUB_EVENTS.variantChange) return;
      this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, message => {
        const data = message.data || message;
        if (String(data.sectionId) !== this.dataset.sectionId) return;
        this.showVariant(data.variant?.id);
      });
    }

    observeInputs() {
      this.observer = new MutationObserver(records => {
        for (const record of records) {
          if (record.type === 'attributes' && this.ownsInput(record.target)) {
            this.showVariant(record.target.value);
          } else if (record.type === 'childList') {
            const changed = [...record.addedNodes, ...record.removedNodes].some(node =>
              node.nodeType === 1 && (node.matches?.('product-form, form, [name="id"]') || node.querySelector?.('form[action*="/cart/add"]')));
            if (changed) this.showVariant(this.variantInput()?.value);
          }
        }
      });
      this.observer.observe(this.root, { subtree: true, childList: true, attributes: true, attributeFilter: ['value'] });
    }

    showVariant(id) {
      const nextId = id == null ? '' : String(id);
      if (nextId !== this.currentId) {
        this.currentId = nextId;
        this.copySequence = (this.copySequence || 0) + 1;
        this.resetCopy();
      }
      this.hidden = !this.dataset.code.trim() || this.byId.get(nextId)?.eligible !== true;
    }

    resetCopy() {
      clearTimeout(this.resetTimer);
      this.removeAttribute('data-copied');
      this.label.textContent = this.dataset.copyLabel || 'Copy code';
      this.status.textContent = '';
    }

    legacyCopy(code) {
      const field = document.createElement('textarea');
      field.value = code;
      field.readOnly = true;
      field.style.cssText = 'position:fixed;top:0;left:-9999px;font-size:16px;';
      this.appendChild(field);
      field.select();
      field.setSelectionRange(0, code.length);
      let copied = false;
      try { copied = document.execCommand('copy'); } catch (_) { /* Announce failure below. */ }
      field.remove();
      this.button.focus({ preventScroll: true });
      return copied;
    }

    async copyCode() {
      if (this.hidden) return;
      const code = this.dataset.code.trim();
      const sequence = this.copySequence = (this.copySequence || 0) + 1;
      let copied = false;
      try {
        if (navigator.clipboard?.writeText) {
          await navigator.clipboard.writeText(code);
          copied = true;
        }
      } catch (_) { /* Try the browser's synchronous copy fallback. */ }
      if (!this.isConnected || sequence !== this.copySequence) return;
      if (!copied) copied = this.legacyCopy(code);
      this.resetCopy();
      if (copied) {
        this.setAttribute('data-copied', '');
        this.label.textContent = this.dataset.copiedLabel || 'Copied!';
        this.status.textContent = `${this.dataset.copiedLabel || 'Copied!'} ${code}`;
      } else {
        this.label.textContent = this.dataset.errorLabel || 'Copy failed';
        this.status.textContent = `${this.dataset.errorLabel || 'Copy failed'}. ${code}`;
      }
      this.resetTimer = setTimeout(() => this.resetCopy(), 2500);
    }
  }
  customElements.define('variant-offer-code', VariantOfferCode);
}


  } catch(e) { console.error(e); }
})();
})();
